<template>
  <hdraces-tickets-list :data-func="getTickets" :show-user="true" />
</template>
<script>
  import hdracesService from '../../../../services/hdraces.service'

  import hdracesTicketsList from '../../../common/hdraces-tickets-list.vue'

  export default {
    name: 'player-hdraces-bets',
    components: { hdracesTicketsList },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      }
    },
    methods: {
      async getTickets(filter) {
        filter.userId = this.playerId;
        return await hdracesService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/player/hdraces-bets.vue